import { Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AppLoader from "../../../components/AppLoader";
import DashboardStatus from "../../../components/Dashboard/DashboardStatus";
import StatusCard from "../../../components/Dashboard/StatusCard";
import NavigationDrawer from "../../../components/NavigationDrawer";
import { getCompanyUpcommingJobs } from "../../../services/company/appointmentApiFn";
import {
  getCompanyDashboardStates,
  getCompanyMonthlyEarning,
} from "../../../services/company/authenticationApiFn";
import { getCompanyPopularServices } from "../../../services/company/serviceCategoryApiFn";
import { handleOpenSnackBar } from "../../../utils";
import JobRequest from "./JobRequest";
import TodaysJobs from "./TodaysJobs";
import TopBusiness from "./TopBusiness";
import TopSale from "./TopSale";
import { t } from "i18next";

let months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const CompanyDashbaord = () => {
  const [isLoading, setIsLoading] = useState({
    states: false,
    jobs: false,
  });
  const [allJobs, setAllJobs] = useState([]);
  const [todaysJobs, setTodaysJobs] = useState([]);
  const [popularService, setPopularService] = useState([]);
  const [dashboardStates, setDashboardStates] = useState(null);
  const [monthlyEarning, setMonthlyEarning] = useState([]);
  const userData = useSelector((state) => state.userData.user);

  useEffect(() => {
    if (userData) {
      fetchDashboardStates();
      fetchAllUpcommingJobs();
      fetchAllPopularService();
      fetchAllMonthlyEarning();
    }
  }, [userData]);

  const fetchDashboardStates = async () => {
    try {
      setIsLoading((l) => ({ ...l, states: true }));
      const response = await getCompanyDashboardStates(userData?.adminId);
      if (response.data.status === "success") {
        const data = response.data.data;
        setDashboardStates(data);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading((l) => ({ ...l, states: false }));
    }
  };

  const fetchAllUpcommingJobs = async () => {
    try {
      setIsLoading((l) => ({ ...l, states: true }));
      const response = await getCompanyUpcommingJobs(userData?.adminId);
      if (response.data.status === "success") {
        const data = response.data.data;
        setAllJobs(data.upcomingJobs);
        setTodaysJobs(data.todaysJobs);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading((l) => ({ ...l, states: false }));
    }
  };

  const fetchAllPopularService = async () => {
    try {
      setIsLoading((l) => ({ ...l, states: true }));
      const response = await getCompanyPopularServices(userData?.adminId);
      if (response.data.status === "success") {
        const data = response.data.data;
        setPopularService(data);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading((l) => ({ ...l, states: false }));
    }
  };

  const fetchAllMonthlyEarning = async () => {
    try {
      setIsLoading((l) => ({ ...l, states: true }));
      const response = await getCompanyMonthlyEarning(userData?.adminId);
      if (response.data.status === "success") {
        let reportData = response?.data?.data;
        const finalReport = reportData.map((val, ind) => {
          return {
            month: months[val.month - 1],
            totalOrders: val.totalAppointments,
            earning: val.totalEarnings,
          };
        });
        setMonthlyEarning(finalReport);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading((l) => ({ ...l, states: false }));
    }
  };

  const cardData = [
    {
      primary: "totalWorkers",
      secondary: "associatedWorkers",
      value: dashboardStates?.totalWorker || 0,
    },
    {
      primary: "totalServices",
      secondary: "totalServiceOffering",
      value: dashboardStates?.totalServices || 0,
    },
    {
      primary: "totalSubService",
      secondary: "totalSubServiceOffering",
      value: dashboardStates?.totalSubServices || 0,
    },
  ];

  return (
    <NavigationDrawer>
      <AppLoader isVisible={isLoading.jobs || isLoading.states} />
      <Typography
        variant="h3"
        fontSize={"1.125rem"}
        fontWeight={600}
        color={"custom.black"}
        textTransform={"capitalize"}
      >
        {t("welcomeDashboard")}
      </Typography>

      <DashboardStatus userImage={userData?.profileImg} />

      <Grid container mt={2} spacing={2} mb={3}>
        {cardData?.map((val, _ind) => {
          return <StatusCard item={val} index={_ind} />;
        })}
      </Grid>

      {/* <MainChart /> */}

      <Grid container mt={3} spacing={2}>
        <Grid item xs={12} md={6}>
          <JobRequest allJobs={allJobs} isLoading={isLoading} />
        </Grid>
        <Grid item xs={12} md={6}>
          <TodaysJobs allJobs={todaysJobs} isLoading={isLoading} />
        </Grid>
        <Grid item xs={12} md={6}>
          <TopSale allServices={popularService} isLoading={isLoading} />
        </Grid>
        <Grid item xs={12} md={6}>
          <TopBusiness monthlyEarning={monthlyEarning} isLoading={isLoading} />
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
};

export default CompanyDashbaord;
